import React, { useRef, useState } from "react";
import Highlight from 'react-highlight'

const TaskCard = (props) => {
    const { task_id, content_title, id_faq, for_faq, question, img_url, answers, language, container_id, img1, img2 } = props.item;

    // const [copySuccess, setCopySuccess] = useState('');
    const textAreaRef = useRef(null);

    function copyToClipboard(e) {
        textAreaRef.current.select();
        document.execCommand('copy');
        // e.target.focus();
    };

    let value = "public class Solution {\npublic int[] TwoSum(int[] nums, int target) {\nint[] result = new int[2];\nfor (int elIndex = 0; elIndex < nums.Length; elIndex++) {\nfor (int elIdx = 0; elIdx < nums.Length; elIdx++) {\nif (nums[elIndex] + nums[elIdx] == target && elIndex != elIdx) {\nresult[0] = elIndex;\nresult[1] = elIdx;\nreturn result;\n}\n}\n}\nreturn result;\n}\n}";


    return (
        <div className="container-flu-item" id={container_id}>
            <div className="title-question">
                <h2>{task_id} тапсырма</h2>
            </div>
            <div className="container-question">
                <p>
                    {question}
                </p>
            </div>
            <div className="faq">
                <div className="faq-item">
                    <input className="faq-input" type="checkbox" id={id_faq} />
                    <label className="faq-title" for={for_faq}>
                        <h6>Жауабын қарау</h6>
                    </label>
                    <div className="faq-text">
                        <div className="text-box">
                            <div className="top-area">
                                <h2>{content_title}</h2>
                                <div className="copy-button" onClick={copyToClipboard}>
                                    <i class="ri-file-copy-line"></i>
                                </div>
                            </div>
                            <img src={`image/${task_id}/${img1}`} alt="" />
                            <img src={`image/${task_id}/${img2}`} alt="" />
                            <Highlight language={language}>
                                {answers}
                            </Highlight>
                            <textarea
                                readOnly
                                spellCheck="false"
                                ref={textAreaRef}
                                value={answers}>
                                    {answers}
                            </textarea>
                            {/* <img src={img_url} alt="" className="w-100 hero__img" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskCard;
